import _defineProperty from "C:\\Building-application-prd\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { publish } from '@jutro/events';
import { REQUEST_HANDLER_TYPE } from '../HttpRequestBuilder';
import { eventTopicMap } from '../common';
export var analyticsHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.TRACE, function (event, payload) {
  publish(eventTopicMap[event], payload);
});